import { Link } from 'react-router-dom'
// import { useTranslation } from 'react-i18next'
import { 
    // RiGithubFill,
    // RiTwitterXFill,
    // RiTelegramFill,
    // RiDiscordFill,
    RiMailLine,
    RiPhoneLine,
    RiMapPinLine,
    RiShieldCheckLine,
    RiTruckLine,
    RiCustomerServiceLine
} from 'react-icons/ri'

import routes from '@/routes/routes'
import { projectName } from '@/utils/constants/common'

import './Footer.css'

const Footer = () => {
    const currentYear = new Date().getFullYear()
    // const { t } = useTranslation('common')
    
    return (
        <footer className="marketplace-footer">
            <div className="footer-container">
                {/* Company Info */}
                <div className="footer-section footer-company">
                    <Link to={routes.home} className="footer-logo">
                        <span className="footer-logo-text">{projectName}</span>
                    </Link>
                    <p className="footer-description">
                        Tu socio de confianza para productos promocionales premium personalizables. 
                        Materiales de calidad, entrega rápida y servicio excepcional.
                    </p>
                    <div className="footer-contact">
                        <div className="contact-item">
                            <RiMailLine className="contact-icon" />
                            <span>support@plastitex.com</span>
                        </div>
                        <div className="contact-item">
                            <RiPhoneLine className="contact-icon" />
                            <span>+1 (555) 123-4567</span>
                        </div>
                        <div className="contact-item">
                            <RiMapPinLine className="contact-icon" />
                            <span>123 Business Ave, Suite 100, City, ST 12345</span>
                        </div>
                    </div>
                </div>

                {/* Quick Links */}
                <div className="footer-section">
                    <h4 className="footer-title">Enlaces Rápidos</h4>
                    <ul className="footer-links">
                        <li><Link to={routes.home}>Inicio</Link></li>
                        <li><Link to={routes.products}>Todos los Productos</Link></li>
                        <li><Link to={routes.categories}>Categorías</Link></li>
                        <li><Link to="/about">Acerca de Nosotros</Link></li>
                        <li><Link to={routes.contact}>Contacto</Link></li>
                    </ul>
                </div>

                {/* Customer Service */}
                <div className="footer-section">
                    <h4 className="footer-title">Atención al Cliente</h4>
                    <ul className="footer-links">
                        <li><Link to="/help">Centro de Ayuda</Link></li>
                        <li><Link to="/shipping">Información de Envío</Link></li>
                        <li><Link to="/returns">Devoluciones e Intercambios</Link></li>
                        <li><Link to="/size-guide">Guía de Tallas</Link></li>
                        <li><Link to="/track-order">Rastrear tu Pedido</Link></li>
                    </ul>
                </div>

                {/* Account */}
                <div className="footer-section">
                    <h4 className="footer-title">Mi Cuenta</h4>
                    <ul className="footer-links">
                        <li><Link to={routes.profile}>Mi Perfil</Link></li>
                        <li><Link to="/orders">Historial de Pedidos</Link></li>
                        <li><Link to="/wishlist">Lista de Deseos</Link></li>
                        <li><Link to={routes.cart}>Carrito de Compras</Link></li>
                        <li><Link to="/addresses">Direcciones</Link></li>
                    </ul>
                </div>

                {/* Trust & Security */}
                <div className="footer-section">
                    <h4 className="footer-title">Confianza y Seguridad</h4>
                    <div className="trust-badges">
                        <div className="trust-item">
                            <RiShieldCheckLine className="trust-icon" />
                            <div>
                                <strong>Pagos Seguros</strong>
                                <p>Checkout encriptado SSL</p>
                            </div>
                        </div>
                        <div className="trust-item">
                            <RiTruckLine className="trust-icon" />
                            <div>
                                <strong>Envío Rápido</strong>
                                <p>2-5 días hábiles</p>
                            </div>
                        </div>
                        <div className="trust-item">
                            <RiCustomerServiceLine className="trust-icon" />
                            <div>
                                <strong>Soporte 24/7</strong>
                                <p>Atención al cliente experta</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Bottom Section */}
            <div className="footer-bottom">
                <div className="footer-bottom-content">
                    <div className="footer-legal">
                        <p className="footer-copyright">
                            © {currentYear} {projectName}. Todos los derechos reservados.
                        </p>
                        <div className="footer-legal-links">
                            <Link to="/privacy">Política de Privacidad</Link>
                            <Link to="/terms">Términos de Servicio</Link>
                            <Link to="/cookies">Política de Cookies</Link>
                        </div>
                    </div>
                    
                    {/* <div className="footer-social">
                        <span className="social-label">Síguenos:</span>
                        <div className="footer-social-icons">
                            <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="social-icon">
                                <RiGithubFill size={20} />
                            </a>
                            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-icon">
                                <RiTwitterXFill size={20} />
                            </a>
                            <a href="https://t.me" target="_blank" rel="noopener noreferrer" className="social-icon">
                                <RiTelegramFill size={20} />
                            </a>
                            <a href="https://discord.com" target="_blank" rel="noopener noreferrer" className="social-icon">
                                <RiDiscordFill size={20} />
                            </a>
                        </div>
                    </div> */}
                </div>
            </div>
        </footer>
    )
}

export default Footer
